const mobilePass = {
  addMobileCredentials: 'Agregar credenciales móviles',
  count: '<1>{{count}}</1> credencial(es) móvil(es) disponible(s)',
  modalTitle: 'KRYPTO Mobile-PASS compra',
  accountName: 'Nombre de la cuenta: ',
  purchaseHistory: 'Historial de compras: ',
  currentlyAvailable: 'Actualmente disponibles: ',
  warning:
    'Está a punto de comprar {{ number }} KRYPTO Mobile-PASS por un total de {{ price }}. ¿Está seguro?',
  outOfMobilePasses:
    'No tienes más pases móviles, por favor contacta a tu distribuidor para añadir más a tu cuenta.',
  count_one: 'Tiene <1>{{ count }}</1> credencial móvil disponible.',
  count_other: 'Tiene <1>{{ count }}</1> credenciales móviles disponibles.',
};

export default mobilePass;
